import { render, staticRenderFns } from "./ChooseAddressCoordinatesDialog.vue?vue&type=template&id=b9d24770&scoped=true&"
import script from "./ChooseAddressCoordinatesDialog.vue?vue&type=script&lang=js&"
export * from "./ChooseAddressCoordinatesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChooseAddressCoordinatesDialog.vue?vue&type=style&index=0&id=b9d24770&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d24770",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VDialog})
